import { useDataChange } from 'Simple/Data'
import { email, phoneNumber } from 'Data/validate.js'

/** @type {import('Simple/types.js').useDataOnChange} */
export default function useDataOnChange(props, data) {
  let questionChange = useDataChange({
    viewPath: props.viewPath,
    context: 'question',
    path: 'answer',
  })

  return function onChange(rvalue, change) {
    change(next => {
      next.emailDetails.isValid = email(rvalue.emailDetails.emailAddress)
      next.phoneDetails.isValid = phoneNumber(rvalue.phoneDetails.phoneNumber)
      next.selected.allowMarketing =
        rvalue.selected.marketingEmail || rvalue.selected.marketingSms || false
      next.selected.allowMarketingMethods =
        rvalue.selected.marketingEmail && rvalue.selected.marketingSms
          ? 'emailAndSms'
          : rvalue.selected.marketingEmail
            ? 'email'
            : rvalue.selected.marketingSms
              ? 'sms'
              : undefined
    })

    if (rvalue.emailDetails.isValid && rvalue.phoneDetails.isValid) {
      questionChange(rvalue)
    } else {
      questionChange(null)
    }
  }
}
